import React from 'react';
import { Svg, Path, Circle, G, Defs, ClipPath, Rect } from '@react-pdf/renderer';
const HondaIncludedIcon = () => (React.createElement(Svg, { style: { width: 16, height: 16 }, viewBox: "0 0 16 16" },
    React.createElement(G, { clipPath: "url(#clip0_23466_6113)" },
        React.createElement(Circle, { cx: "8", cy: "8", r: "8", fill: "#004478" }),
        React.createElement(Path, { d: "M6.30654 9.8885L3.98856 7.74293L3.19922 8.46841L6.30654 11.3446L12.977 5.17031L12.1932 4.44482L6.30654 9.8885Z", fill: "white" })),
    React.createElement(Defs, null,
        React.createElement(ClipPath, { id: "clip0_23466_6113" },
            React.createElement(Rect, { width: "16", height: "16", fill: "white" })))));
export default HondaIncludedIcon;
